import { IClaimHandlerEntity } from '../entitites/claim-handler.entity';

export class ClaimHandlerDto {
  readonly name: string;
  readonly jobTitle: string;
  readonly email: string | null;
  readonly phone: string | null;

  constructor(handler: IClaimHandlerEntity) {
    this.name = handler.name;
    this.jobTitle = handler.job_title;
    this.email = handler.email ?? null;
    this.phone = handler.phone ?? null;
  }
}
